// extracted by mini-css-extract-plugin
export var defaultWrapper = "_li-3";
export var downloadButton = "_li-4";
export var fileContainer = "_li-9 _li-7";
export var fileContainerBase = "_li-7";
export var fileContainerFixedHeight = "_li-8 _li-7";
export var fileInfo = "_li-5";
export var fileInfoWidthRestricted = "_li-6";
export var fileType = "_li-1";
export var fileTypeName = "_li-2";
export var image = "_li-0";
export var link = "_li-b";
export var overflowEllipsis = "_li-a";